/* eslint-disable */
import React, { Component, createRef } from 'react';
import ReactGA from 'react-ga';
import { Helmet } from 'react-helmet';
import { useParams } from 'react-router-dom';
import { isMobile  } from 'react-device-detect';
import SSOFT_SOLUTION_EAM_SEO_1344 from '../../sections/SSoft_Solution_EAM_Seo_1344/SSoft_Solution_EAM_Seo';
import SSOFT_HERO_SIDE_946 from '../../sections/SSoft_Hero_Side_946/SSoft_Hero_Side';
import SSOFT_SOLUTION_WHY_1334 from '../../sections/SSoft_Solution_Why_1334/SSoft_Solution_Why';
import SSOFT_SOLUTIONS_SLIDER_940 from '../../sections/SSoft_Solutions_Slider_940/SSoft_Solutions_Slider';
import SSOFT_SOLUTIONS_DETAIL_CARD_941 from '../../sections/SSoft_Solutions_Detail_Card_941/SSoft_Solutions_Detail_Card';
import SSOFT_SOLUTION_KEY_FEATURES_947 from '../../sections/SSoft_Solution_Key_Features_947/SSoft_Solution_Key_Features';
import SSOFT_SOLUTIONS_QUESTION_CARDS_955 from '../../sections/SSoft_Solutions_Question_Cards_955/SSoft_Solutions_Question_Cards';
import SSOFT_SOLUTIONS_MORE_INFO_957 from '../../sections/SSoft_Solutions_More_Info_957/SSoft_Solutions_More_Info';
import SSOFT_RELATED_PAGES_948 from '../../sections/SSoft_Related_Pages_948/SSoft_Related_Pages';

function withParams(Component) {
    return props => <Component {...props} params={useParams()} />;
}

class project1 extends Component {
   constructor(props) {
       super(props);
       this.state = {
           currentPage: null,
           currentSection: null,
           override: true,
           section: [
               { id: 1, slug: localStorage.getItem('language') === "English"? 'seo' : 'seo'},
               { id: 2, slug: localStorage.getItem('language') === "English"? 'hero' : 'hero'},
               { id: 3, slug: localStorage.getItem('language') === "English"? 'why-choose-us' : 'why-choose-us'},
               { id: 4, slug: localStorage.getItem('language') === "English"? 'solution-slider' : 'solution-slider'},
               { id: 5, slug: localStorage.getItem('language') === "English"? 'solutions-detail-cards' : 'solutions-detail-cards'},
               { id: 6, slug: localStorage.getItem('language') === "English"? 'features' : 'features'},
               { id: 7, slug: localStorage.getItem('language') === "English"? 'solutions-question-cards' : 'solutions-question-cards'},
               { id: 8, slug: localStorage.getItem('language') === "English"? 'more-info' : 'more-info'},
               { id: 9, slug: localStorage.getItem('language') === "English"? 'related-pages' : 'related-pages'},
           ],
       };
       this.scrollToSection = this.scrollToSection.bind(this);
       this.scrollAction = this.scrollAction.bind(this);
        this.isStateChanging = false
   }
   componentDidMount() {
       this.scrollToSection();
       ReactGA.initialize('')
       ReactGA.pageview(window.location.pathname + window.location.search);
   }
   componentWillUnmount(){
   }
   section1 = createRef()
   section2 = createRef()
   section3 = createRef()
   section4 = createRef()
   section5 = createRef()
   section6 = createRef()
   section7 = createRef()
   section8 = createRef()
   section9 = createRef()
   scrollToSection() {
       let currentLocation = window.location.href
       const hasSectionAnchor = currentLocation.includes('/#')
       if (hasSectionAnchor) {
           let anchorSectionId = `${currentLocation.substring(currentLocation.indexOf('#') + 1)}`
           setTimeout(() => { this.scrollAction(anchorSectionId) }, 1000)
       }
   }
   scrollAction(anchorSectionId) {
       const uri_dec = decodeURIComponent(anchorSectionId)
       const key = this.state.section.filter(x => x.slug == uri_dec).map(obj => `section${obj.id}`)
       const getY = (element) => element.getBoundingClientRect().top + window.pageYOffset - 140;
       if (key) {
          if (key[0] === 'section1') {
               setTimeout(() => {window.scrollTo({ top: getY(this.section1.current), behavior: 'smooth' })}, 1000)
          } else if (key[0] === 'section2') {
               setTimeout(() => {window.scrollTo({ top: getY(this.section2.current), behavior: 'smooth' })}, 1000)
          } else if (key[0] === 'section3') {
               setTimeout(() => {window.scrollTo({ top: getY(this.section3.current), behavior: 'smooth' })}, 1000)
          } else if (key[0] === 'section4') {
               setTimeout(() => {window.scrollTo({ top: getY(this.section4.current), behavior: 'smooth' })}, 1000)
          } else if (key[0] === 'section5') {
               setTimeout(() => {window.scrollTo({ top: getY(this.section5.current), behavior: 'smooth' })}, 1000)
          } else if (key[0] === 'section6') {
               setTimeout(() => {window.scrollTo({ top: getY(this.section6.current), behavior: 'smooth' })}, 1000)
          } else if (key[0] === 'section7') {
               setTimeout(() => {window.scrollTo({ top: getY(this.section7.current), behavior: 'smooth' })}, 1000)
          } else if (key[0] === 'section8') {
               setTimeout(() => {window.scrollTo({ top: getY(this.section8.current), behavior: 'smooth' })}, 1000)
          } else if (key[0] === 'section9') {
               setTimeout(() => {window.scrollTo({ top: getY(this.section9.current), behavior: 'smooth' })}, 1000)
            }
       }
   }
   render() {
       const getHelmetTitle = () => {
           var title;
           switch (localStorage.getItem('language')) {
               case 'English':
                   title = <title> Enterprise Asset Management | Supersoft</title>;
                   break;
               case 'Indonesian':
                   title = <title> Manajemen Aset Perusahaan | Supersoft</title>;
                   break;
               default:
                   title = <title> Enterprise Asset Management | Supersoft</title>;
                   break;
           }
           return title;
       };
       const getHelmetDescription = () => {
           var description;
           switch (localStorage.getItem('language')) {
               case 'English':
                   description = <meta name='description' content='Explore Infor EAM: Maximize automation for efficient assets, spending, and agile work management - PT Supersoft' />;
                   break;
               case 'Indonesian':
                   description = <meta name='description' content='Telusuri Infor EAM: Maksimalkan otomatisasi aset, pengeluaran, dan manajemen pekerjaan agar nilai terintegrasi - PT Supersoft' />;
                   break;
               default:
                   description = <meta name='description' content='Explore Infor EAM: Maximize automation for efficient assets, spending, and agile work management - PT Supersoft' />;
                   break;
           }
           return description;
       };
       const getHelmetKeywords = () => {
           var keywords;
           switch (localStorage.getItem('language')) {
               case 'English':
                   keywords = <meta name='keywords' content='' />;
                   break;
               case 'Indonesian':
                   keywords = <meta name='keywords' content='' />;
                   break;
               default:
                   keywords = <meta name='keywords' content='' />;
                   break;
           }
           return keywords;
       };
         let helmet = getHelmetTitle();
         let description = getHelmetDescription();
         let keywords = getHelmetKeywords();
       return (
           <>
               <Helmet>
                   {helmet}
                   {description}
                   {keywords}
               </Helmet>
            <div ref={this.section1}>
                <SSOFT_SOLUTION_EAM_SEO_1344 />
            </div>
            <div ref={this.section2}>
                <SSOFT_HERO_SIDE_946 />
            </div>
            <div ref={this.section3}>
                <SSOFT_SOLUTION_WHY_1334 />
            </div>
            <div ref={this.section4}>
                <SSOFT_SOLUTIONS_SLIDER_940 />
            </div>
            <div ref={this.section5}>
                <SSOFT_SOLUTIONS_DETAIL_CARD_941 />
            </div>
            <div ref={this.section6}>
                <SSOFT_SOLUTION_KEY_FEATURES_947 />
            </div>
            <div ref={this.section7}>
                <SSOFT_SOLUTIONS_QUESTION_CARDS_955 />
            </div>
            <div ref={this.section8}>
                <SSOFT_SOLUTIONS_MORE_INFO_957 />
            </div>
            <div ref={this.section9}>
                <SSOFT_RELATED_PAGES_948 />
            </div>
           </>
       );
   }
}
export default withParams(project1);